export default __webpack_public_path__ + "static/media/Upload_list_of.ea3e7024.png";